import { api } from './api';

export const fetchPayments = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/payment', params, options);
};

export const fetchPaymentById = (id) => {
  return api.get(`/payment/${id}`);
};

export const fetchPaymentMethods = (data) => {
  return api.get('/payment_method', data);
};

export const addPaymentMethod = (data) => {
  return api.post('/payment_method', data);
};

export const deletePaymentMethod = (id) => {
  return api.delete(`/payment_method/${id}`);
};

export const fetchUpdatePaymentMethod = (id, data) => {
  return api.put(`payment_method/${id}`, data);
};

export const fetchVerifyPaymentMethod = (id, data) => {
  return api.post(`payment_method/${id}/verify`, data);
};
